import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ScheduleDownloadButtonService} from './schedule-download-button.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {FadeOutAnimation} from '@helpers/animations/fadeInOut.animation';
import {DropdownDirective} from '@lab365/common';

@Component({
    selector: 'app-calibration-schedule-download-button',
    templateUrl: './schedule-download-button.component.html',
    styleUrls: ['./schedule-download-button.component.scss'],
    providers: [
        ScheduleDownloadButtonService,
    ],
    animations: [
        FadeOutAnimation,
    ]
})
export class ScheduleDownloadButtonComponent implements OnInit, OnDestroy {

    constructor(
        private service: ScheduleDownloadButtonService,
    ) {
    }

    @ViewChild(DropdownDirective) dropdown: DropdownDirective;

    ngOnInit() {
        this.service.cancel$.pipe(
            untilDestroyed(this),
        ).subscribe(() => {
            this.dropdown.close();
        });
    }

    ngOnDestroy(): void {

    }
}
